import { render, staticRenderFns } from "./VEmployerServicesExtensionTemplate.vue?vue&type=template&id=323a5379&scoped=true&lang=pug"
import script from "./VEmployerServicesExtensionTemplate.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesExtensionTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerServicesExtensionTemplate.vue?vue&type=style&index=0&id=323a5379&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a5379",
  null
  
)

export default component.exports